export enum SimType {
  VOICE = 'voice',
  DATA = 'data',
  ALL_IN_ONE = 'all_in_one',
  ALL_IN_ONE_UNLIMITED = 'all_in_one_unlimited',
  MB_SHARING = 'mbsharing',
}
